module.exports = __webpack_public_path__ + "static/media/customer.d62b2fed.svg";